const quickLinks = [
  { label: 'Escritório', id: 'sobre' },
  { label: 'Áreas de Atuação', id: 'areas' },
  { label: 'Como Atuamos', id: 'como-atuamos' },
  { label: 'Contato', id: 'contato' },
];

const areas = [
  'Direito Imobiliário',
  'Sucessões',
  'Atuação Extrajudicial',
  'Direito Previdenciário',
  'Direito Trabalhista',
  'Direito Agrário',
  'Direito Ambiental',
];

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#141C2E] text-white/60 text-sm">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-5 h-14">
              <img
                src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/ef045d39655e3e00acde9d0b7a8eacd3.png"
                alt="Jocimar Tadioto Advocacia"
                className="h-full w-auto object-contain"
              />
            </div>
            <p className="text-white/45 text-xs leading-relaxed mb-4">
              Advocacia estratégica com atuação multidisciplinar em Campo Grande/MS. Soluções jurídicas com segurança, técnica e profissionalismo.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.instagram.com/jocimartadiotoadv/"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#1F2A44] hover:bg-[#C8B07A] rounded-lg transition-colors duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-white hover:text-[#1F2A44] text-lg transition-colors duration-300"></i>
              </a>
              <a
                href="https://wa.me/5567999210516"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#1F2A44] hover:bg-[#C8B07A] rounded-lg transition-colors duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-white hover:text-[#1F2A44] text-lg transition-colors duration-300"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 id="footer-links" className="text-white font-semibold text-sm mb-5 tracking-wide">
              <a href="#sobre">Links Rápidos</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-white/45 hover:text-[#C8B07A] transition-colors duration-300 text-xs cursor-pointer whitespace-nowrap flex items-center gap-1.5"
                  >
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[#C8B07A] text-xs"></i>
                    </span>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 id="footer-areas" className="text-white font-semibold text-sm mb-5 tracking-wide">
              <a href="#areas">Áreas de Atuação</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {areas.map((area) => (
                <li key={area}>
                  <button
                    onClick={() => scrollTo('areas')}
                    className="text-white/45 hover:text-[#C8B07A] transition-colors duration-300 text-xs cursor-pointer whitespace-nowrap flex items-center gap-1.5"
                  >
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[#C8B07A] text-xs"></i>
                    </span>
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 id="footer-contact" className="text-white font-semibold text-sm mb-5 tracking-wide">
              <a href="#contato">Contato</a>
            </h4>
            <ul className="flex flex-col gap-4">
              <li>
                <a
                  href="https://wa.me/5567999210516"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-start gap-2 hover:text-[#C8B07A] transition-colors duration-300 cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-whatsapp-line text-[#C8B07A] text-sm"></i>
                  </span>
                  <span className="text-xs">+55 67 99921-0516</span>
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-[#C8B07A] text-sm"></i>
                </span>
                <span className="text-xs leading-relaxed text-white/45">
                  Av. Afonso Pena, 2440 – Sala 123<br />
                  Centro – Campo Grande/MS<br />
                  CEP: 79002-074
                </span>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/jocimartadiotoadv/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-2 hover:text-[#C8B07A] transition-colors duration-300 cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-instagram-line text-[#C8B07A] text-sm"></i>
                  </span>
                  <span className="text-xs">@jocimartadiotoadv</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-white/5"></div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-white/30 text-xs text-center sm:text-left">
          <strong className="text-white/50">Jocimar Tadioto Sociedade Individual de Advocacia</strong>
        </div>
        <div className="flex items-center gap-4 text-xs text-white/25">
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="nofollow noreferrer"
            className="text-white/30 hover:text-[#C8B07A] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Desenvolvido por Start Digital
          </a>
          <span className="hidden sm:inline text-white/15">|</span>
          <button
            onClick={() => scrollTo('hero')}
            className="hidden sm:inline-flex items-center gap-1 text-white/30 hover:text-[#C8B07A] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-up-line text-sm"></i>
            </span>
            Voltar ao topo
          </button>
        </div>
      </div>
    </footer>
  );
}
